import { render, staticRenderFns } from "./footballLeagueFull_CSL.vue?vue&type=template&id=36077ef0"
import script from "./footballLeagueFull_CSL.vue?vue&type=script&lang=js"
export * from "./footballLeagueFull_CSL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports